import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export const RedirectTo = (props:{to:string,replace:boolean}) => {
    const navigate = useNavigate();
    useEffect(() => {
        navigate(props.to,{replace:props.replace});
    }, [navigate, props.replace, props.to]);
    return (<></>);
};